import React from 'react';

import { Breadcrumbs, Grid, Skeleton, Table, TableRow, TableCell, TableBody, TableHead } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';
import AdminSettingsContainer from '../../../AdminSettingsContainer';

import HomeContainer from './HomeContainer';
import ModalContainer from '../../../ModalContainer';
import StyledFormTitle from '../../../styles/form-title';
import ColorfulRectangle from './ColorfulRectangle';
import TroubleshootingErrorRow from './TroubleshootingErrorRow';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Title = styled(StyledFormTitle)`
    margin-bottom: 1rem;
`;

const Spacer = styled.div`
    margin: 1rem;
`;

const PaddedSkeleton = styled(Skeleton)`
    margin: .5rem 0;
`;

const StyledTableHeaderCell = styled(TableCell)`
    font-weight: bolder;
    font-size: 14px;
`;

export const HomeDetail = () => {
    console.log('HomeDetail');
    const { t } = useTranslation('portal');
    const { homeData, insightsDetailErrors } = useContainer(HomeContainer);
    console.log(homeData, insightsDetailErrors);
    const { adminSettings, school } = useContainer(AdminSettingsContainer);
    const { featureSettings } = adminSettings;
    const { pushModalContent } = useContainer(ModalContainer);

    if (!homeData || homeData.loading) {
        return (
            <>
                <Grid container justifyContent="space-between">
                    <Grid item><Skeleton width={300} height={60}/></Grid>
                    <Grid item><Skeleton width={150} height={60}/></Grid>
                </Grid>
                <Spacer />
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <Spacer />
                <Grid container justifyContent="flex-end">
                    <Skeleton width={400} height={50}/>
                </Grid>
            </>
        );
    }

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb">
                <Link to="/portal/home">{t('home-page.home')}</Link>
            </Breadcrumbs>
            <div style={{ textAlign: 'center' }}>
                <h1 style={{ textAlign: 'center', marginBottom: '64px' }}>{school!.name}</h1>
                <h2 style={{ textAlign: 'center' }}>{t('overall-health-grade')}</h2>
                <div style={{ fontWeight: 'bold', fontSize: 48, marginTop: '8px', marginBottom: '12px' }}>{Math.round(100 * homeData?.calculated?.grade)}</div>
                <div style={{ fontSize: '12px', marginBottom: '10px' }}>{t('an-aggregate-of-the-grades-below')}</div>
                {homeData && <ColorfulRectangle style={{ marginLeft: 'auto', marginRight: 'auto', overflow: 'hidden', borderRadius: '6px' }} value={homeData?.calculated?.grade} width={700} height={30}/>}
                <Table style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '40px' }}>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{ width: '230px', textAlign: 'center' }}>
                                <div style={{ fontWeight: 'bold' }}>{t('errors-per-minute-grade')}</div>
                                <div style={{ fontWeight: 'bold', fontSize: 32, marginTop: '8px', marginBottom: '8px' }}>{Math.round(100 * homeData?.calculated?.errorsPerMeetingMinutesGrade)}</div>
                                <div style={{ fontSize: '13.5px' }}>{t('one-error-every')} {Math.round(homeData?.raw?.meetingMinutesPerError)} {t('meeting-minutes')}</div>
                            </TableCell>
                            <TableCell style={{ width: '230px', textAlign: 'center' }}>
                                <div style={{ fontWeight: 'bold' }}>{t('vanilla-zoom-users-grade')}</div>
                                <div style={{ fontWeight: 'bold', fontSize: 32, marginTop: '8px', marginBottom: '8px' }}>{Math.round(100 * homeData?.calculated?.vanillaZoomStatesGrade)}</div>
                                <div style={{ fontSize: '13.5px' }}>{Math.round(homeData?.raw?.numberOfTotalZoomStates / homeData?.raw?.numberOfTotalZoomStates)}% {t('vanilla-zoom-users')}</div>
                            </TableCell>
                            {featureSettings.allowAiForSupport && <TableCell style={{ width: '230px', textAlign: 'center' }}>
                                <div style={{ fontWeight: 'bold' }}>{t('sentiment-grade')}</div>
                                <div style={{ fontWeight: 'bold', fontSize: 32, marginTop: '8px', marginBottom: '8px' }}>{Math.round(100 * homeData?.calculated?.sentimentGrade)}</div>
                                <div style={{ fontSize: '13.5px' }}>{t('average-user-sentiment-of')} {Math.round(100 * homeData?.raw?.averageSentiment) / 100}</div>
                            </TableCell>}
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ width: '230px', textAlign: 'center' }}>
                                {homeData && <ColorfulRectangle value={homeData?.calculated?.errorsPerMeetingMinutesGrade} width={160} height={30} style={{ marginLeft: 'auto', marginRight: 'auto', overflow: 'hidden', borderRadius: '6px' }} />}
                            </TableCell>
                            <TableCell style={{ width: '230px', textAlign: 'center' }}>
                                {homeData && <ColorfulRectangle value={homeData?.calculated?.vanillaZoomStatesGrade} width={160} height={30} style={{ marginLeft: 'auto', marginRight: 'auto', overflow: 'hidden', borderRadius: '6px' }} />}
                            </TableCell>
                            {featureSettings.allowAiForSupport && <TableCell style={{ width: '230px', textAlign: 'center' }}>
                                {homeData && <ColorfulRectangle value={homeData?.calculated?.sentimentGrade} width={160} height={30} style={{ marginLeft: 'auto', marginRight: 'auto', overflow: 'hidden', borderRadius: '6px' }} />}
                            </TableCell>}
                        </TableRow>
                    </TableBody>
                </Table>
                {featureSettings.allowAiForSupport && <><h1 style={{ marginTop: '60px' }}>{t('sentiment-analysis')}</h1>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ borderBottom: 'none', padding: '10px', width: '50%', verticalAlign: 'top' }}>
                                    <div style={{ paddingTop: '20px', border: '1px solid rgb(200,200,200)', maxHeight: '450px', overflowY: 'auto' }}>
                                        <div style={{ textAlign: 'center', marginBottom: '20px' }}><div style={{ fontSize: '18px', fontWeight: 'bolder', marginBottom: '8px' }}>{t('at-risk-instructors')}</div><div>{t('at-risk-instructors-description')}</div></div>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableHeaderCell>{t('user-name')}</StyledTableHeaderCell>
                                                    <StyledTableHeaderCell>{t('email')}</StyledTableHeaderCell>
                                                    <StyledTableHeaderCell>{t('issue-count')}</StyledTableHeaderCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {homeData?.atRiskUsers?.map((user, key) => <TableRow key={key} style={{ backgroundColor: (key % 2 === 0) ? '#f6f6f6' : '#fff' }} onClick={() => pushModalContent(
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <StyledTableHeaderCell>{t('issue-type')}</StyledTableHeaderCell>
                                                                <StyledTableHeaderCell>{t('issue-topic')}</StyledTableHeaderCell>
                                                                <StyledTableHeaderCell>{t('issue-text')}</StyledTableHeaderCell>
                                                                <StyledTableHeaderCell>{t('description')}</StyledTableHeaderCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {user.issues?.map((issue, innerKey) => <TableRow key={innerKey} style={{ backgroundColor: (innerKey % 2 === 0) ? '#f6f6f6' : '#fff' }}><TableCell>{issue.type}</TableCell><TableCell>{issue.topic}</TableCell><TableCell>{issue.text}</TableCell><TableCell>{issue.description}</TableCell></TableRow>)}
                                                        </TableBody>
                                                    </Table>
                                                )}><TableCell>{user.user_name}</TableCell><TableCell>{user.email}</TableCell><TableCell>{user.issues_count}</TableCell></TableRow>)}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </TableCell>
                                <TableCell style={{ borderBottom: 'none', padding: '10px', width: '50%', verticalAlign: 'top' }}>
                                    <div style={{ paddingTop: '20px', border: '1px solid rgb(200,200,200)', maxHeight: '450px', overflowY: 'auto' }}>
                                        <div style={{ textAlign: 'center', marginBottom: '20px' }}><div style={{ fontSize: '18px', fontWeight: 'bolder', marginBottom: '8px' }}>{t('at-risk-features')}</div><div>{t('at-risk-features-description')}</div></div>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableHeaderCell>{t('issue-topic')}</StyledTableHeaderCell>
                                                    <StyledTableHeaderCell>{t('issue-count')}</StyledTableHeaderCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {homeData?.troubleshootingTopicsArray?.map((troubleshootingTopic, key) => <TableRow key={key} style={{ backgroundColor: (key % 2 === 0) ? '#f6f6f6' : '#fff' }} onClick={() => pushModalContent(
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <StyledTableHeaderCell>{t('issue-type')}</StyledTableHeaderCell>
                                                                <StyledTableHeaderCell>{t('issue-topic')}</StyledTableHeaderCell>
                                                                <StyledTableHeaderCell>{t('issue-text')}</StyledTableHeaderCell>
                                                                <StyledTableHeaderCell>{t('description')}</StyledTableHeaderCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {troubleshootingTopic.issues?.map((issue, innerKey) => <TableRow key={innerKey} style={{ backgroundColor: (innerKey % 2 === 0) ? '#f6f6f6' : '#fff' }}><TableCell>{issue.type}</TableCell><TableCell>{issue.topic}</TableCell><TableCell>{issue.text}</TableCell><TableCell>{issue.description}</TableCell></TableRow>)}
                                                        </TableBody>
                                                    </Table>
                                                )}><TableCell>{troubleshootingTopic.topic}</TableCell><TableCell>{troubleshootingTopic.count}</TableCell></TableRow>)}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <Table style={{ marginTop: '30px' }}>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ borderBottom: 'none', padding: '10px', width: '100%', verticalAlign: 'top' }}>
                                    <div style={{ paddingTop: '20px', border: '1px solid rgb(200,200,200)', maxHeight: '450px', overflowY: 'auto' }}>
                                        <div style={{ textAlign: 'center', marginBottom: '20px' }}><div style={{ fontSize: '18px', fontWeight: 'bolder', marginBottom: '8px' }}>{t('recent-issues')}</div><div>{t('recent-issues-description')}</div></div>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableHeaderCell>{t('issue-type')}</StyledTableHeaderCell>
                                                    <StyledTableHeaderCell>{t('issue-topic')}</StyledTableHeaderCell>
                                                    <StyledTableHeaderCell>{t('issue-text')}</StyledTableHeaderCell>
                                                    <StyledTableHeaderCell>{t('description')}</StyledTableHeaderCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {homeData?.troubleshootingItemsArray?.map((troubleshootingItem, key) => <TableRow key={key} style={{ backgroundColor: (key % 2 === 0) ? '#f6f6f6' : '#fff' }}><TableCell>{troubleshootingItem.item.type}</TableCell><TableCell>{troubleshootingItem.item.topic}</TableCell><TableCell>{troubleshootingItem.item.text}</TableCell><TableCell>{troubleshootingItem.item.description}</TableCell></TableRow>)}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table></>}
                <Table style={{ marginTop: '30px' }}>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{ borderBottom: 'none', padding: '10px', width: '100%', verticalAlign: 'top' }}>
                                <div style={{ paddingTop: '20px', border: '1px solid rgb(200,200,200)', maxHeight: '450px', overflowY: 'auto' }}>
                                    <div style={{ textAlign: 'center', marginBottom: '20px' }}><div style={{ fontSize: '18px', fontWeight: 'bolder', marginBottom: '8px' }}>{t('recent-error')}</div><div>{t('recent-errors-description')}</div></div>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableHeaderCell>{t('platform')}</StyledTableHeaderCell>
                                                <StyledTableHeaderCell>{t('count')}</StyledTableHeaderCell>
                                                <StyledTableHeaderCell>{t('title')}</StyledTableHeaderCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {insightsDetailErrors.map((troubleshootingError, index) => <TroubleshootingErrorRow style={{ backgroundColor: (index % 2 === 0) ? '#f6f6f6' : '#fff' }} error={troubleshootingError} key={index}></TroubleshootingErrorRow>)}
                                        </TableBody>
                                    </Table>
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        </>
    );
};
